import React from "react";
import "./styles.less";
import { useTranslation } from "react-i18next";
import { tryNow } from "../../utils";
import { AuthingButton } from "../../components/AuthingButton";

export const TryOn = (props) => {
  const { style } = props;
  const { t } = useTranslation();

  return (
    <div className="try-on" style={style ? style : {}}>
      <AuthingButton style={{ marginRight: 24 }} onClick={() => tryNow()}>
        {t("common.try-on")}
      </AuthingButton>
      <AuthingButton
        className="pc-show"
        mode="light"
        onClick={() => {
          window.open("https://docs.authing.cn/v2/guides/");
        }}
      >
        {t("common.button.linkDoc")}
      </AuthingButton>
    </div>
  );
};
